import APIError from '../APIError';

class AccountProfitError extends APIError {
  constructor(code, details = null) {
    super(code, 'AccountProfitError', details);
  }
}

export default AccountProfitError;
